import { render, staticRenderFns } from "./ExchangeInstitution.vue?vue&type=template&id=11e8523e&"
import script from "./ExchangeInstitution.vue?vue&type=script&lang=ts&"
export * from "./ExchangeInstitution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports